import store from './store';
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from './pages/Layout'
import Logowanie from './pages/Logowanie'
import ZmianaHasla from './pages/ZmianaHasla'
//import PierwszaZmianaHasla from './pages/PierwszaZmianaHasla'

import Pulpit from './pages/Pulpit'
import PulpitObecne from './pages/PulpitObecne'
import PulpitNieobecne from './pages/PulpitNieobecne'
import PulpitBezStatusu from './pages/PulpitBezStatusu'
import PulpitNieodebrane from './pages/PulpitNieodebrane'

import Uzytkownicy from './pages/Uzytkownicy'
import Placowki from './pages/Placowki.vue'
import Stanowiska from './pages/Stanowiska'
import Lata from './pages/Lata'
import Cenniki from './pages/Cenniki'
import Grupy from './pages/Grupy'
import Grupa from './pages/Grupa'
import Dzieci from './pages/Dzieci'
import Dziecko from './pages/Dziecko'

import Dziennik from './pages/Dziennik'

import Rozliczenia from './pages/Rozliczenia'

import DokumentyKasowe from './pages/DokumentyKasowe'
import RaportyKasowe from './pages/RaportyKasowe'
import WyciagiKasowe from './pages/WyciagiKasowe'
import RaportWindykacyjny from './pages/RozliczeniaNieoplacone'

import GodzinyCennika from './pages/reports/GodzinyCennika'
import NaleznosciGrup from './pages/reports/NaleznosciGrup'

import Empty from './pages/Empty'

import _isEmpty from "lodash/isEmpty"

import MenuPulpit from './components/MenuPulpit'
import MenuUstawienia from './components/MenuUstawienia'
import MenuSlowniki from './components/MenuSlowniki'
import MenuKasa from './components/MenuKasa'
import MenuRaporty from './components/MenuRaporty'

Vue.use(VueRouter)

function requireAuth (to, from, next) {
  function proceed () {
    if ( store.getters.getUserLoadStatus() == 2 ) {

      if(!_isEmpty(store.getters.getUser)){//zalogowany
        
        if(!store.getters.getUser.oneTimePassword){//hasło jednorazowe

          //sprawdzanie uprawnien
          if(to.meta.module==='')next();
          else if( store.getters.getUser.permissions[to.meta.module] >= 5 )next();
          else next('/pulpit');

        }else{
          next('/haslo');
        }

      }else{
        next('/logowanie');
      }
    }
  }

  

  if ( store.getters.getUserLoadStatus() != 2 ) {
    store.dispatch( 'loadUser' );
    store.watch( store.getters.getUserLoadStatus, function(){
          if( store.getters.getUserLoadStatus() == 2 ){
              proceed();
          }
    });
  } else {
    proceed()
  }
}

function requireAuthOneTime (to, from, next) {
  function proceed () {
    
    if ( store.getters.getUserLoadStatus() == 2 ) {
      if( !_isEmpty(store.getters.getUser) ){//zalogowany

           //sprawdzanie uprawnien
           if(to.meta.module==='')next();
           else if( store.getters.getUser.permissions[to.meta.module] >= 5 )next();
           else next('/pulpit');
  
      }else{
        next('/logowanie');
      }
    }
  }

  if ( store.getters.getUserLoadStatus() != 2 ) {
    store.dispatch( 'loadUser' );
    store.watch( store.getters.getUserLoadStatus, function(){
          if( store.getters.getUserLoadStatus() == 2 ){
              proceed();
          }
    });
  } else {
    proceed()
  }
}

const routes = [
  
  { path: '/',
    redirect: { name: 'ustawienia.placowki' },
    name: 'Layout',
    component:Layout,
    children:[
      {
        path: '/logowanie', name: 'logowanie', component: Logowanie
      },
      //{path: '/jednorazowe', name: 'jednorazowe', component: PierwszaZmianaHasla, beforeEnter: requireAuthOneTime, meta: { module: ''}},
      {
        path: '/haslo',
        name: 'haslo',
        component: ZmianaHasla,
        beforeEnter: requireAuthOneTime,
        meta: {
          module: ''
        }
      },
      {
        path: '/pulpit',
        name: 'pulpit',
        components: {
          default: Pulpit,
          menu: MenuPulpit
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'desktop'
        }
      },
      {
        path: '/pulpit/obecne',
        name: 'pulpit.obecne',
        components: {
          default: PulpitObecne,
          menu: MenuPulpit
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'desktop'
        }
      },
      {
        path: '/pulpit/nieobecne',
        name: 'pulpit.nieobecne',
        components: {
          default: PulpitNieobecne,
          menu: MenuPulpit
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'desktop'
        }
      },
      {
        path: '/pulpit/bezstatusu',
        name: 'pulpit.bezstatusu',
        components: {
          default: PulpitBezStatusu,
          menu: MenuPulpit
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'desktop'
        }
      },
      {
        path: '/pulpit/nieodebrane',
        name: 'pulpit.nieodebrane',
        components: {
          default: PulpitNieodebrane,
          menu: MenuPulpit
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'desktop'
        }
      },
      {
        path: '/ustawienia/placowki',
        name: 'ustawienia.placowki',
        components: {
          default: Placowki,
          menu: MenuUstawienia
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'setting'
        }
      },
      {
        path: '/ustawienia/uzytkownicy',
        name: 'ustawienia.uzytkownicy',
        components: {
          default: Uzytkownicy,
          menu: MenuUstawienia
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'setting'
        }
      },
      {
        path: '/ustawienia/stanowiska',
        name: 'ustawienia.stanowiska',
        components: {
          default: Stanowiska,
          menu: MenuUstawienia
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'setting'
        }
      },
      {
        path: '/slowniki/lata',
        name: 'slowniki.lata',
        components: {
          default: Lata,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/slowniki/cenniki',
        name: 'slowniki.cenniki',
        components: {
          default: Cenniki,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/slowniki/grupy',
        name: 'slowniki.grupy',
        components: {
          default: Grupy,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/slowniki/grupa/:id/:year_id',
        name: 'slowniki.grupa',
        params:true,
        components: {
          default: Grupa,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/slowniki/dzieci',
        name: 'slowniki.dzieci',
        components: {
          default: Dzieci,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/slowniki/dziecko/:id/:year_id',
        name: 'slowniki.dziecko',
        params:true,
        components: {
          default: Dziecko,
          menu: MenuSlowniki
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'dictionary'
        }
      },
      {
        path: '/raporty/godziny',
        name: 'raporty.godziny',
        components: {
          default: GodzinyCennika,
          menu: MenuRaporty
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'report'
        }
      },
      {
        path: '/raporty/naleznosci',
        name: 'raporty.naleznosci',
        components: {
          default: NaleznosciGrup,
          menu: MenuRaporty
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'report'
        }
      },
      {
        path: '/rozliczenia',
        name: 'rozliczenia',
        component: Rozliczenia,
        beforeEnter: requireAuth,
        meta: {
          module: 'settlement'
        }
      },
      {
        path: '/kasa/dokumenty',
        name: 'kasa.dokumenty',
        components: {
          default: DokumentyKasowe,
          menu: MenuKasa
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'payment'
        }
      },
      {
        path: '/kasa/raporty',
        name: 'kasa.raporty',
        components: {
          default: RaportyKasowe,
          menu: MenuKasa
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'payment'
        }
      },
      {
        path: '/kasa/wyciagi',
        name: 'kasa.wyciagi',
        components: {
          default: WyciagiKasowe,
          menu: MenuKasa
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'payment'
        }
      },
      {
        path: '/kasa/windykacje',
        name: 'kasa.windykacje',
        components: {
          default: RaportWindykacyjny,
          menu: MenuKasa
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'payment'
        }
      },
      {
        path: '/kasa',
        name: 'kasa',
        component: Empty,
        beforeEnter: requireAuth,
        meta: {
          module: 'payment'
        }
      },
      {
        path: '/dziennik',
        name: 'dziennik',
        components: {
          default: Dziennik
        },
        beforeEnter: requireAuth,
        meta: {
          module: 'journal'
        }
      },
    ]
  },
  
  
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
